import { FJCommonAPIClass } from '@src/core/network/FJCommonAPI.ts';
import FJUtil from '@src/util/FJUtil';

export class FJPublishAPIClass extends FJCommonAPIClass {
    async createSocialSharingDescription(
        eventId: string,
        subId: string,
        title: string,
        description: string,
        subtitles: any[],
        platforms: string[],
        scope: string | string[] = 'all',
    ) {
        const url = this._baseUrl + 'v1/ai/social-sharing';
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('sub_id', subId);
        formData.append('title', title);
        formData.append('description', description);
        formData.append('subtitles', JSON.stringify(subtitles));
        formData.append('platforms', JSON.stringify(platforms));
        formData.append('scope', typeof scope === 'string' ? scope : JSON.stringify(scope));
        this._addTeamIdToFormData(formData);
        const headers: any = {};
        if (FJUtil.isLocalhost()) {
            headers.uuid = 'a1525281952@gmail.com';
        }
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            headers: headers,
        });

        const response = await res.json();
        const { data, code } = response;
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    }

    async savePublishedData(eventId: string, subId: string, social: string, data: any) {
        const url = this._baseUrl + 'v1/ai/save-social-sharing-info';
        const formData = new FormData();
        formData.append('event_id', eventId);
        formData.append('sub_id', subId);
        formData.append('social', social);
        formData.append('data', JSON.stringify(data));
        this._addTeamIdToFormData(formData);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
        });

        const response = await res.json();
        const { code } = response;
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return true;
    }

    public async getPublishedData(eventId: string, subId: string) {
        const url = `${this._baseUrl}v1/ai/get-social-sharing-info?event_id=${eventId}&sub_id=${subId}`;

        const res = await fetch(url, { method: 'GET' });

        const response = await res.json();
        const { data, code } = response;
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    }
}

const api = new FJPublishAPIClass();
export default api;
